export default {
  placeholder: 'Wähle ein Anlagenlevel',
};
